module.exports = __webpack_public_path__ + "img/serotonin.f5731f53.jpg";